import getStore from '../store/store';
export default function getSharingLink(linkId) {
    var store = getStore();
    return store.sharingLinks.get(linkId);
}
//# sourceMappingURL=getSharingLink.js.map